import { useState, useEffect } from 'react';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
const SortingModalWaiverMain = (props) => {
  const { isMobile } = useMobileSettings();
  const [component, setComponent] = useState(null);

  useEffect(() => {
    const loadComponent = async () => {
      if (isMobile) {
        const module = await import(
          '../MobileComponents/SortingModalWaiverMob'
        );
        setComponent(() => module.default);
      } else {
        const module = await import('../WebComponents/SortingModalWaiverWeb');
        setComponent(() => module.default);
      }
    };

    loadComponent();
  }, [isMobile]);

  const LoadedComponent = component;
  return component ? <LoadedComponent {...props} /> : <></>;
};

export default SortingModalWaiverMain;
